import React, { useEffect, useState } from "react";

const STEPS = [
  "Parsing conversation structure…",
  "Scanning for gaslighting & DARVO…",
  "Evaluating tone & contempt markers…",
  "Mapping blame-shifting patterns…",
  "Calculating narcissism divergence…",
  "Compiling forensic scorecard…",
];

export const ScanOverlay = () => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((p) => (p + 1) % STEPS.length), 1400);
    return () => clearInterval(t);
  }, []);
  return (
    <div className="scan-overlay" data-testid="analyzing-overlay">
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 28 }}>
        <div className="radar">
          <div className="ring" style={{ inset: 0 }} />
          <div className="ring" style={{ inset: 28 }} />
          <div className="ring" style={{ inset: 56 }} />
          <div className="ring pulse-ring" style={{ inset: 60, borderColor: "rgba(220,38,38,0.6)" }} />
          <div className="sweep" />
          <div
            style={{
              position: "absolute",
              inset: 0,
              display: "grid",
              placeItems: "center",
              fontFamily: "Geist Mono, monospace",
              color: "#dc2626",
              fontSize: 13,
              letterSpacing: "0.2em",
            }}
          >
            ANALYSING
          </div>
        </div>
        <div style={{ height: 22, overflow: "hidden" }}>
          <div
            key={i}
            className="fade-up"
            style={{ color: "var(--muted)", fontSize: 14, fontFamily: "Geist Mono, monospace" }}
          >
            {STEPS[i]}
          </div>
        </div>
      </div>
    </div>
  );
};
